import React from 'react';
import { Wrench, Layers } from 'lucide-react';

const BusinessServicesSection = ({ services, businessServiceContext }) => {
  // Alias context
  const businessService = businessServiceContext;

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-orange-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Wrench className="h-5 w-5 text-orange-500" />
        <h3 className="text-xl font-semibold text-gray-800">
          Servicios Registrados
        </h3>
      </div>

      {services && services.length > 0 ? (
        <div className="space-y-4">
          {services.map((service) => {
            // Safety check for helper function
            const formatted = businessService?.formatServiceData
              ? businessService.formatServiceData(service)
              : { 
                  priceDisplay: `$${service.service_price || '0.00'}`,
                  capacityText: service.service_capacity || 'N/A'
                };

            return (
              <div 
                key={service.service_id || service.id} 
                className="border border-gray-200 rounded-lg p-4 hover:bg-orange-50 transition-colors duration-200"
              >
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <div className="flex items-center gap-2">
                      <h4 className="font-medium text-gray-800 text-lg">
                        {service.service_name}
                      </h4>
                      {service.service_category && (
                        <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-blue-50 text-blue-700">
                          <Layers className="mr-1 h-3 w-3" />
                          {service.service_category}
                        </span>
                      )}
                    </div>
                    
                    <p className="text-sm text-gray-600 mt-2">
                      {service.service_description || 'Sin descripción disponible.'}
                    </p>
                    
                    <div className="flex flex-wrap items-center gap-3 mt-3 text-sm text-gray-500">
                      <span className="bg-gray-100 px-2 py-1 rounded">
                        Capacidad: {formatted.capacityText}
                      </span>
                      {service.service_duration && (
                        <span className="bg-gray-100 px-2 py-1 rounded">
                          Duración: {service.service_duration} min
                        </span>
                      )}
                    </div>
                  </div>
                  
                  <div className="flex flex-col items-end ml-4">
                    <span className="text-lg font-bold text-orange-600 whitespace-nowrap">
                      {formatted.priceDisplay}
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
          <Wrench className="h-12 w-12 text-gray-300 mx-auto mb-3" />
          <h4 className="text-lg font-medium text-gray-700">No hay servicios registrados</h4>
          <p className="text-gray-500 text-sm mt-1">
            Este negocio no ofrece servicios actualmente.
          </p>
        </div>
      )}
    </div>
  );
};

export default BusinessServicesSection;